import claimDataReducer from "./claimData"
import uiDataReducer from "./uiData"
import dropdownData from "./dropdownData"

import { combineReducers } from "redux"

const allReducers = combineReducers({
  dropdownData: dropdownData,
  claimData: claimDataReducer,
  uiData: uiDataReducer,
})

export default allReducers
